// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gfilm-theme-provider[data-v-327e7086]{color:var(--g-text-primary);caret-color:var(--g-text-primary)}.gfilm-theme-provider.fill-background[data-v-327e7086]{background-color:var(--g-background-primary);border-color:var(--g-background-primary)}.gfilm-theme-provider[data-v-327e7086] a:not(.gala-btn){color:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
